module.exports = "<div class=\"IntroVideo\">\n  <div class=\"IntroVideo-gradient\"></div>\n  <div class=\"IntroVideo-cover lazypreload lazyload\" data-bgset=\"{{ ::ctrl.video.coverMobile }} 745w, {{ ::ctrl.video.cover }} 1280w\" data-sizes=\"auto\"></div>\n\n  <div class=\"IntroVideo-content\">\n    <h2 ng-bind-html=\"::ctrl.video.heading\"></h2>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/common/intro_videos/intro_video.html
// module id = 299
// module chunks = 24